import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const DEAL_STAGE = 'DEAL_STAGE';
export const FORECAST_CATEGORY = 'FORECAST_CATEGORY';
export const FORECAST_COLUMNS = 'hs-forecast-columns';
export const DEAL_GROUPING_TYPE = {
  DEAL_STAGE: {
    columnLimit: 0,
    defaultColumnSlice: 0,
    propertyPath: 'stages',
    valueFieldName: 'stageId',
    dealQueryKey: 'dealStages',
    propertyName: 'dealstage',
    filterCountSelectedText: count => /*#__PURE__*/_jsx(FormattedMessage, {
      message: "repOverviewTable.filters.dealStage.countSelected",
      options: {
        count
      }
    }),
    filterLabelText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "repOverviewTable.filters.dealStage.label"
    }),
    allSelectedText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "repOverviewTable.filters.dealStage.all_text"
    })
  },
  FORECAST_CATEGORY: {
    columnLimit: -5,
    defaultColumnSlice: -3,
    propertyName: 'hs_manual_forecast_category',
    propertyPath: 'options',
    valueFieldName: 'value',
    dealQueryKey: 'forecastCategories',
    filterCountSelectedText: count => /*#__PURE__*/_jsx(FormattedMessage, {
      message: "repOverviewTable.filters.forecastCategory.countSelected",
      options: {
        count
      }
    }),
    filterLabelText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `repOverviewTable.filters.forecastCategory.label`
    }),
    allSelectedText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: 'repOverviewTable.filters.forecastCategory.all_text'
    })
  }
};